<template>
    <div>
        <div class="content_box">
            <v-card flat class="settings_panel_card">
                <v-toolbar flat dense class="settings_toolbar">
                        

                    <v-toolbar-title class="settings_panel_heading">Users with access</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon color="grey lighten-3" v-if="!showUsersWithoutAccessList" depressed small>
                        <v-icon :class="usersWithoutAccessData.length == 0 ? 'emptyUsers' : ''" @click="showListOfUserWithoutAccess()" >add</v-icon>
                    </v-btn>

                    <v-btn icon color="grey lighten-3" v-else depressed small>
                        <v-icon :class="usersWithoutAccessData.length == 0 ? 'emptyUsers' : ''" @click="cancellistOfUserWithoutAccess()" >clear</v-icon>
                    </v-btn>

                </v-toolbar>
                <!-- <v-divider></v-divider> -->
                <div class="apps_table_div">
                    <table class="users_with_access_component_table">
                        <thead>
                        <tr>
                            <th>User</th>
                            <th>Last Used </th>
                            <th>App Role</th>
                            <th>App administrator</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in usersWithAccessData" :key="index">
                                <td>
                                    <v-icon color="purple">person</v-icon>&nbsp;
                                    {{item.username}}
                                </td>
                                <td>{{item.last_login || '-'}}</td>
                                <td v-if="!apptypeRoles.length">
                                    {{item.role[0]}}
                                </td>
                                <td v-else>
                                    <v-select
                                        v-model="item.role"
                                        :items="apptypeRoles"
                                        label="App role"
                                        multiple
                                        chips
                                        @input="selectedDropDownValue(item)"
                                    >
                                    </v-select>
                                </td>
                                <td>
                                    <span v-if="item.user_role == 'appAdmin' || item.user_role == 'User'">
                                        <i class="material-icons checkBox" title="remove user as app admin" v-if="item.is_appAdmin" @click="makeUserAsAppAdminMethod(item,index,'true')">check_box</i>
                                        <i class="material-icons checkBox" title="make user as app admin" v-else @click="makeUserAsAppAdminMethod(item,index,'false')">check_box_outline_blank</i>
                                    </span>
                                    <span v-else> 
                                        <i class="material-icons checkBox_disable" title="User is tenant admin or Super admin">check_box</i>
                                    </span>
                                </td>
                                <td><i class="material-icons user_delete" @click="addDeleteUser(item,'delete')">clear</i></td>
                            </tr>
                            <tr v-for="(item,index) in usersWithoutAccessData" v-if="showUsersWithoutAccessList">
                                <td>
                                    <v-icon color="purple">person</v-icon>&nbsp;
                                    {{item.username}}
                                </td>
                                <td>{{item.last_login}}</td>
                                <td>
                                    {{item.role}}
                                </td>
                                <td>
                                    <span v-if="item.user_role == 'appAdmin' || item.user_role == 'User'">
                                        <i class="material-icons checkBox" title="remove user as app admin" v-if="item.is_appAdmin" @click="makeUserAsAppAdminMethod(item,index,'true')">check_box</i>
                                        <i class="material-icons checkBox" title="make user as app admin" v-else @click="makeUserAsAppAdminMethod(item,index,'false')">check_box_outline_blank</i>
                                    </span>
                                    <span v-else> 
                                        <i class="material-icons checkBox_disable" title="User is tenant admin or Super admin">check_box</i>
                                    </span>
                                </td>
                                <td><button class="user_table_Add" @click="addDeleteUser(item,'add')">add</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </v-card>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
export default {
    name:'userWithAccess',
    props: {
        apptoken: {
            type: String
        },
        nodeValue:{
            type:String
        }
    },
    data(){
        return{
            showUsersWithoutAccessList:false,
            usersWithAccessData:[],
            userResponse:[],
            apptypeRoles:[],
            usersWithoutAccessData:[],
            showEmptyUsersMessage:false,
            appRolesForUserwithAccess: [],
            values:[],
            hide:null
        }
    },
    watch: {
        apptoken(){
            var self = this;
            if(!self.isappAdmin){
                self.getUsersData(self.apptoken);
            }
        }
    },
    mounted(){
        if(!this.isappAdmin){
            this.getUsersData(this.apptoken);
        }
    },
    computed: {
        ...mapState({
            isappAdmin: state => state.loginDetails.loggedInUserInformation['is_appadmin'],
        }),
    },
    methods:{
        ...mapActions({
            getAllUsersData: 'usersDetails/getAllUsersData',
        }),
        getUsersData(tokens){
            var self = this;
            // self.users_object = {};
            self.apptypeRoles = [];
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/get_users/',{
                params:{
                    'apptoken' : self.apptoken,
                    'node':self.nodeValue
                }
            })
            .then((res)=>{
                try{
                    self.userResponse = jQuery.parseJSON(JSON.stringify(res.data));
                    var user_with_access_response_data = []
                    self.showEmptyUsersMessage = false;
                    if(self.userResponse.apptype_roles.length>0){
                        self.apptypeRoles = self.userResponse.apptype_roles;
                    }
                    self.usersWithAccessData = [];
                    self.usersWithAccessData = jQuery.parseJSON(JSON.stringify(self.userResponse.users_with_access)); 
                    self.usersWithoutAccessData = self.userResponse.users_without_access;
                    for(var item in self.userResponse.users_with_access){
                        if(self.userResponse.users_with_access.hasOwnProperty(item)){
                            // self.appRolesForUserwithAccess.push(self.userResponse.users_with_access[item]['role']);
                            self.appRolesForUserwithAccessappRolesForUserwithAccess = self.userResponse.users_with_access[item]['role'];
                            if(self.userResponse.users_with_access[item].last_login == null){
                                self.userResponse.users_with_access[item].last_login = 'unused';
                            }
                            else{
                                var user_last_used_date = self.userResponse.users_with_access[item].last_login.substring(0,10);
                                self.userResponse.users_with_access[item].last_login = user_last_used_date ;
                            }
                            self.userResponse.users_with_access[item].role = self.userResponse.users_with_access[item].role[0];
                        }

                    }
                    for(var item in self.userResponse.users_without_access){
                        if(self.userResponse.users_without_access[item].last_login == null){
                            self.userResponse.users_without_access[item].last_login = 'unused';
                        }
                        else{
                            var user_last_used_date = self.userResponse.users_without_access[item].last_login.substring(0,10);
                            self.userResponse.users_without_access[item].last_login = user_last_used_date;
                        }
                        self.userResponse.users_without_access[item].role = self.userResponse.users_without_access[item].role[0];
                        
                    }
                    if(self.usersWithAccessData.length == 0 && self.usersWithoutAccessData.length == 0 ){
                        self.showEmptyUsersMessage = true;
                    }
                    //     self.users_data.push(self.users_object);
                    // }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error)=>{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                //console.log("api failed with error");
            })
        },
        showListOfUserWithoutAccess(){
            var self = this;
            self.showUsersWithoutAccessList = true;
        },
        cancellistOfUserWithoutAccess(){
            var self = this;
            self.showUsersWithoutAccessList = false;
        },
       
        //method to add or delete user     
        addDeleteUser(item,action){
            var self = this;
            let formData = new FormData();
            let action_type ='';
            if(action == 'add'){
                action_type = 'add';
            }
            else{
                action_type = 'delete';
            }
            formData.append('json', JSON.stringify({'apptoken': self.apptoken,
            'action':action_type,
            'pk':item.id,
            'node':self.nodeValue}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/get_users/',formData)
            .then((res) => {
                try{
                    self.getUsersData(self.apptoken);
                    self.getAllUsersData();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                //console.log("api failed with error:" + error)
            });
        },
        makeUserAsAppAdminMethod(item,index,val){
            var self = this;
            if(val == 'false'){
                item.is_appAdmin = true;
            }
            else{
                item.is_appAdmin = false;
            }
            let formData = new FormData();
            formData.append('json', JSON.stringify({'apptoken': self.apptoken,
            'action':'addAdmin',
            'is_appAdmin': item.is_appAdmin,
            'pk':item.id,
            'node':self.nodeValue}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/get_users/',formData)
            .then((res) => {
                try{
                    //console.log(res);
                    self.getUsersData(self.apptoken);
                    self.getAllUsersData();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                //console.log("api failed with error:" + error)
            });

        },
        selectedDropDownValue(item){
            var self = this;
            let formData = new FormData();
            formData.append('json', JSON.stringify({'apptoken': self.apptoken,
            'action':'updaterole',
            'role':item.role,
            'is_appAdmin': item.is_appAdmin,
            'pk':item.id,
            'node':self.nodeValue}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/get_users/',formData)
            .then((res) => {
                try{
                    self.getUsersData(self.apptoken);
                    self.getAllUsersData();
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                //console.log("api failed with error:" + error)
            });
            self.appRolesForUserwithAccess = [];
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
